/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { State } from 'app/gamma/src/modules/types';
import React, { lazy, Suspense, FunctionComponent, useCallback } from 'react';
import { connect } from 'react-redux';
import { isEnterpriseAdmin } from 'app/gamma/src/selectors/enterprises';
import HeaderButton from './button';
import { usePopover, Popover } from '@trello/nachos';
import { forNamespace } from 'app/common/lib/util/i18n';

const EnterpriseMenuPromise = import(
  /* webpackChunkName: "enterprise-menu-popover" */ 'app/gamma/src/components/popovers/enterprise-menu'
);
const EnterpriseMenu = lazy(() => EnterpriseMenuPromise);

const viewTitle = forNamespace('view title');

interface StateProps {
  isAdmin: boolean;
}

const EnterpriseMenuButton: FunctionComponent<StateProps> = ({ isAdmin }) => {
  const { toggle, hide, triggerRef, popoverProps } = usePopover<
    HTMLButtonElement
  >();
  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ENTERPRISE_DASHBOARD_MENU,
      method: 'by clicking enterprise button in header',
    });
    toggle();
  }, [toggle]);
  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <HeaderButton
        icon={IconName.Enterprise}
        onClick={onClick}
        ref={triggerRef}
        testId={HeaderTestIds.EnterpriseDashboardButton}
      />
      <Popover {...popoverProps} title={viewTitle('trello enterprise')}>
        <Suspense fallback={null}>
          <EnterpriseMenu onEnterpriseSelected={hide} />
        </Suspense>
      </Popover>
    </>
  );
};

const mapStateToProps = (state: State): StateProps => ({
  isAdmin: isEnterpriseAdmin(state),
});

export default connect(mapStateToProps)(EnterpriseMenuButton);
